import * as client_hooks from '../../../src/hooks.client.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/_loom": [5],
		"/_prototype": [6],
		"/_prototype/tinymcecloud": [7],
		"/account": [8],
		"/admin": [9],
		"/admin/email": [10],
		"/content-calendar": [11],
		"/internal/organizations": [12],
		"/internal/organizations/[orgId]": [13],
		"/login": [14],
		"/pricing": [15],
		"/pricing/success": [16],
		"/projects": [17,[2]],
		"/projects/new": [27,[2]],
		"/projects/[projectId]": [18,[2,3]],
		"/projects/[projectId]/assets": [19,[2,3]],
		"/projects/[projectId]/canvas": [20,[2,3]],
		"/projects/[projectId]/document": [21,[2,3]],
		"/projects/[projectId]/document/[id]": [22,[2,3]],
		"/projects/[projectId]/new-request": [23,[2,3]],
		"/projects/[projectId]/requests/[id]": [24,[2,3]],
		"/projects/[projectId]/requests/[id]/edit": [25,[2,3]],
		"/projects/[projectId]/requests/[id]/storyboard": [26,[2,3]],
		"/register": [28],
		"/requests": [29],
		"/requests/new": [30],
		"/scope": [31],
		"/sentry-example": [32],
		"/sop": [33],
		"/stand-ups": [34],
		"/talent": [35],
		"/talent/[id]": [36],
		"/test": [37],
		"/vime": [38]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';